import { packageTypeMap } from 'stores/adapters/bex-api/search/multi-item/package-type-adapter';
export const mapMultiItemContextInput = multiItemContext => {
  if (!multiItemContext) {
    return null;
  }
  return {
    id: multiItemContext.id,
    packageType: packageTypeMap[multiItemContext.packageType]
  };
};